import React from 'react';
import Carousel from './CustomeCrousal';

function App() {
  const carouselItems = [
    <div className="slide" style={{ background: '#f0f0f0' }}>Slide 1</div>,
    <div className="slide" style={{ background: '#e0e0e0' }}>Slide 2</div>,
    <div className="slide" style={{ background: '#d0d0d0' }}>Slide 3</div>,
    <div className="slide" style={{ background: '#c0c0c0' }}>Slide 4</div>,
  ];

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h1>Animated Progress Carousel</h1>
      <Carousel 
        items={carouselItems} 
        autoPlay={true}
        interval={4000} // 4 seconds per slide
      />
    </div>
  );
}

export default App;